import { MemberAccess } from "@/interfaces/permission.interface";
import { useAppSelector } from ".";
import { Permission } from "@/interfaces";

export const usePermission = (module: string): Permission => {
  const permissions = useAppSelector((state) => state.auth.permission);

  const permissionMap = new Map(permissions.map((p) => [p.module.toLowerCase(), p]));

  const permission = permissionMap.get(module);
  return {
    read: !!permission?.read,
    create: !!permission?.create,
    update: !!permission?.update,
    delete: !!permission?.delete,
  };
};
